import Logo from "@shared/assets/premium/logo.svg?react"
import { cn } from "@shared/lib/utils"
import { useEffect } from "react"
import { preload } from "react-dom"
import { showMonsterPromo } from "@/entities/subscription"
import { useIsPremium } from "@/entities/user"
import * as m from "@/paraglide/messages"
import bgBlur from "@/shared/assets/premium/bg-blur.webp"
import bgBlurCircle from "@/shared/assets/premium/bg-blur-circle.webp"
import promoBannerCardsEn from "@/shared/assets/premium/promo-banner-eng-cards.webp"
import promoBannerCardsRu from "@/shared/assets/premium/promo-banner-rus-cards.webp"
import { useLocale } from "@/shared/lib/i18n"
import { useStoreId } from "@/shared/lib/platform"

function MonsterButton() {
	const locale = useLocale()
	const store = useStoreId()
	const variant = useIsPremium() ? "compact" : "full"
	const label =
		store === "app-store" ? m.monsterBtnLabelIos() : m.monsterBtnLabel()
	// Отрисован только русский баннер — остальные локали берут английский.
	const promoBannerCards =
		locale === "ru" ? promoBannerCardsRu : promoBannerCardsEn

	useEffect(() => {
		preload(promoBannerCards, { as: "image" })
	}, [promoBannerCards])

	return (
		<div className="relative isolate">
			{variant === "full" ? (
				<img
					src={bgBlur}
					alt=""
					aria-hidden
					width="266"
					height="136"
					className="pointer-events-none absolute inset-0 -z-10 m-auto scale-x-125 scale-y-115"
					decoding="async"
				/>
			) : (
				<img
					src={bgBlurCircle}
					alt=""
					aria-hidden
					width="132"
					height="128"
					className="pointer-events-none absolute inset-0 bottom-0.5 -z-10 m-auto scale-200"
					decoding="async"
				/>
			)}
			<button
				type="button"
				onClick={() => showMonsterPromo()}
				className={cn(
					"inline-flex items-center justify-center bg-black text-xs leading-5.5 font-extrabold tracking-[1px] text-white ring-2 ring-[#d7d3fb]",
					variant === "full"
						? "gap-2.5 rounded-2xl py-1 pr-4 pl-1.25"
						: "rounded-full p-1",
				)}
			>
				<Logo className="size-6" aria-hidden />
				{variant === "full" && label}
			</button>
		</div>
	)
}

export { MonsterButton }
